import CalendarComponent from 'components/Calendar3/Calendar';
import DaycareBookingsModal from 'components/Calendar/DaycareBookingsModal';
import React, { FunctionComponent, useState } from 'react';
import PrivatePage from './PrivatePage';

export const Calendar: FunctionComponent = () => {
    const [selectedDaycareDate, setSelectedDaycareDate] = useState<string>();

    return (
        <PrivatePage
            title="Calendar - Cuddles"
            pageName="/calendar"
        >
            <CalendarComponent onDaycareDayClick={date => setSelectedDaycareDate(date.format('YYYY-MM-DD'))} />
            {selectedDaycareDate && (
                <DaycareBookingsModal
                    date={selectedDaycareDate}
                    onClose={() => setSelectedDaycareDate(undefined)}
                />
            )}
        </PrivatePage>
    );
};

export default Calendar;
